import React , {Fragment} from 'react'
import { Panel, PopDeleteConfirm } from 'components/ui';
import { injectIntl } from 'react-intl';
import { Table, Icon, Button, Modal} from 'antd';
import { connect } from 'react-redux';
import PropTypes from 'prop-types'
import {
  fetchApiTokenList,
  addApiToken,
  deleteApiToken,
  updateApiToken
} from '../flow/action'
import ModelForm from './ModalForm'
import { addError } from '../../../../store/error/action';
import PERMISSIONS from 'config/app-permission.config';
import { Permission } from 'components/page/index';

const propTypes = {
  apiTokenList: PropTypes.array.isRequired,
  fetchApiTokenList: PropTypes.func.isRequired,
  addApiToken: PropTypes.func.isRequired,
  addError: PropTypes.func.isRequired,
  deleteApiToken: PropTypes.func.isRequired,
  updateApiToken: PropTypes.func.isRequired,
}

class ApiTokenPanel extends React.Component {

    state ={
      visible: false,
      selectedToken: '',
      selectedTokenId: null
    }

    // fetch the token list 
    componentDidMount(){
      this.props.fetchApiTokenList()
    }

    // delete token
    handelDeleteToken = (id) => {
        this.props.deleteApiToken(id)
    }
    // update token
    handleUpdateToken = () => {
       this.form.validateFields()
        .then(values => {
          this.props.updateApiToken(this.state.selectedTokenId, values.name)
          this.setState({visible: false, selectedToken: '', selectedTokenId: null})
        })
        .catch(e => addError(formatMessage({id: `page.ApiToken.error`})))
    }

    //add new token
    handleAddToken = () => {
      const {intl} = this.props
      const {formatMessage} = intl
      const {apiTokenList, addError, addApiToken} = this.props

       if(apiTokenList.length > 19){
         addError(formatMessage({id: `page.ApiToken.lengthError`}))
         this.setState({visible: false})
       }else{
        this.form.validateFields()
          .then(values => {
            addApiToken(values.name)
            this.setState({ visible: false });
          })
          .catch(e => addError(formatMessage({id: `page.ApiToken.updateError`})))
       }  
    }

    //open the modal from the add button
    handleOpen = () => {
      this.setState({ visible: true, selectedToken: '', selectedTokenId: null });
    }

    // open the modal from the edit
    handleEditOpen = (id, name) => {
      this.setState({
        visible: true,
        selectedToken: name,
        selectedTokenId: id
      })
    }
    
    //closes the modal
    handleCancel = () => {
      this.setState({ visible: false });
      this.form.resetFields('name');
    }

    //submit form action
    handleTokenListAction = () => {
      if(this.state.selectedToken){
        this.handleUpdateToken()
      }else{
        this.handleAddToken()
      }
    }

    render(){
        const {apiTokenList} = this.props
        const {intl} = this.props
        const {formatMessage} = intl
        // Table columns
        const columns = [{
            title: formatMessage({id: `page.ApiToken.action`}),
            key: 'id',
            width: '5%',
            render: record => (
                  <Fragment>
                      <Permission permission = {PERMISSIONS.SETUP_APITOKEN_UPDATE}>
                        <Icon
                              className="cursor-pointer"
                              size="small"
                              type="edit"
                              onClick={() => this.handleEditOpen(record.id, record.name)}
                          />
                      </Permission>
                      <Permission permission = {PERMISSIONS.SETUP_APITOKEN_DELETE}>
                        <PopDeleteConfirm
                            placement="right"
                            onConfirm={() => this.handelDeleteToken(record.id)}
                            >
                            <Icon className="ml-md cursor-pointer" type="delete" />
                        </PopDeleteConfirm>
                      </Permission>
                  </Fragment>
                )
          }, {
            title: formatMessage({id: `page.ApiToken.tokenName`}),
            key: 'name',
            dataIndex: 'name',
          }, {
            title: formatMessage({id: `page.ApiToken.apiToken`}),
            key: 'remember_token',
            width: '75%',
            dataIndex: 'remember_token',
          }, {
            title: formatMessage({id: `page.ApiToken.createdDate`}),
            key: 'created_at',
            dataIndex: 'created_at'
          }, 
          {
            title: formatMessage({id: `page.ApiToken.expireDate`}),
            key: 'expires_at',
            dataIndex: 'expires_at'
          }];
      
        // top right corner button
        const rightActions = (
            <Permission permission={PERMISSIONS.SETUP_APITOKEN_ADD}>
                <Button
                  key="addBtn"
                  className="btn-ellipse ml-sm"
                  size="small"
                  icon="plus"
                  onClick = {this.handleOpen}
                >
                  {formatMessage({id: `page.ApiToken.add`})}
                </Button>
            </Permission>
          );

        return (
          <Permission permission={PERMISSIONS.SETUP_APITOKEN_VIEW}>
            <Panel
                panelTitle={formatMessage({id: `page.ApiToken.apiToken`})}
                actionsRight={rightActions}
                contentClasses="pt-lg pb-lg pl-lg pr-lg"
            >
                <Table
                    dataSource={apiTokenList}
                    columns={columns}
                    pagination={false}
                    rowKey="id"
                    style={{wordBreak:'break-word'}}
                />
                <Modal
                  title = {formatMessage({id: `page.ApiToken.addToken`})}
                  visible = {this.state.visible}
                  onCancel={() => this.handleCancel()}
                  footer={[
                    <div style={{display:'flex', justifyContent:'center'}}>
                      <Button icon='save' key="save" size="small" type="default" onClick={() => this.handleTokenListAction()}> 
                        {formatMessage({id: `page.ApiToken.saveToken`})}
                      </Button>
                      <Button icon='close' key="cancel" size="small" type="danger" onClick={() => this.handleCancel()}>
                        {formatMessage({id: `page.ApiToken.cancel`})}
                      </Button>
                    </div>
                   
                  ]}
                >
                  <ModelForm
                    ref={(c) => { this.form = c; }}
                    views = {this.state.selectedToken}
                  />
                </Modal>
            </Panel>
          </Permission>
        )
    }
}

const mapStateToProps = (state) => ({
  apiTokenList: state.setup.apiToken.apiTokenList,
  lang: state.global.language
})
const mapDispatchToProps = {
  fetchApiTokenList,
  addApiToken,
  addError,
  deleteApiToken,
  updateApiToken
}

ApiTokenPanel.propTypes = propTypes

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(ApiTokenPanel))


// WEBPACK FOOTER //
// ./src/views/Setup/ApiToken/components/apiTokenPanel.js